export const Endpoints = {
  login: "auth/login",
  users: "users",
  password_recovery: "password-reset/send-recovery-email",
  password_reset: "password-reset/change-password",
  admins: "admins",
  pricing_profiles: "pricing-profiles",
  chargers: "chargers",
  locations: "locations",
  sessions: "sessions",
  connector_types: "connector-types",
  home_general: "admin/dashboard/general",
  home_monitoring: "admin/dashboard/monitoring",
  ocpp_events: "ocpp-events",
  location_images: "location-images",
  charger_connectors: "charger-connectors",
  manual_commands: "manual-commands",
  partnerships: "partnerships",
  amenities: "location-amenities",
  charger_iot_channels: "charger-iot-channel-configs",
};
